export default {
      id: "i-yt-usage",
      viewBox: "0 0 28 29",
      url: __webpack_public_path__ + "img/sprite.svg#i-yt",
      toString: function () {
        return this.url;
      }
    }